var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadCrumb',{attrs:{"items":_vm.breadCrumb}}),_c('EditQuizForm',{key:(_vm.quiz ? _vm.quiz.id : 0),attrs:{"book_id":_vm.book_id,"value":_vm.quiz,"busy":_vm.quizLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }